import React, { useEffect, useState } from "react";
import { environment } from "environment/environment";
import "./Profile.css";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../common/AuthContext";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Profile = () => {
//   const { user, logout, isLoading } = useAuth();
const { user, isLoading } = useAuth();
  const navigate = useNavigate();
  const [userPlanByUserId, setUserPlanByUserId] = useState(null);

  // ✅ Redirect to login if not logged in
  useEffect(() => {
    if (!isLoading && !user) {
      navigate("/login");
    }
  }, [user, isLoading, navigate]);

  // ✅ Fetch user plan by userId
  useEffect(() => {
    const fetchUserPlan = async (userId) => {
      if (!userId) return;

      try {
        const response = await fetch(
          `${environment.baseUrl}/user-pan/get-user-plain-by-user-id?userId=${userId}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        );

        const res = await response.json();

        if (res.status && res.data) {
          setUserPlanByUserId(res.data);
          console.log("Fetched userPlanByUserId => ", res.data);
        } else {
          toast.warn("No plan data found for this user!");
        }
      } catch (error) {
        console.error("Error fetching user plan:", error);
        toast.error("Error fetching user plan!");
      }
    };

    if (user?.userId) {
      fetchUserPlan(user.userId);
    }
  }, [user]);

//   const handleLogout = () => {
//     logout();
//     navigate("/login");
//   };

  if (isLoading) return <div className="loading">Loading...</div>;
  if (!user) return null;

  return (
    <div className="profile-container">
      <div className="welcome-banner fade-in">
        <div>
          <h2 className="welcome-title">
            Welcome back, {user?.userName || "User"}!
          </h2>
          <p className="welcome-text">
            Ready to continue your journey? Let’s see what’s new today.
          </p>
        </div>
      </div>

      <div className="info-card-top">
        <section className="card">
          <h2>User Details</h2>
          <div className="detail-row">
            <span className="label">User ID:</span>
            <span className="value">{user?.userId || "--"}</span>
          </div>
          <div className="detail-row">
            <span className="label">Name:</span>
            <span className="value">{user?.userName || "--"}</span>
          </div>
          <div className="detail-row">
            <span className="label">Mobile:</span>
            <span className="value">{user?.mobileNumber || "--"}</span>
          </div>
          <div className="detail-row">
            <span className="label">Email:</span>
            <span className="value">{user?.email || "--"}</span>
          </div>
          <div className="detail-row">
            <span className="label">Post:</span>
            <span className="value">Admin</span>
          </div>
        </section>

        <section className="card">
          <h2>Plan & Validity</h2>
          <div className="detail-row">
            <span className="label">Plan:</span>
            <span className="value">
              {userPlanByUserId?.planName || "--"} ₹
              {userPlanByUserId?.planAmount ?? "N/A"}
            </span>
          </div>
          <div className="detail-row">
            <span className="label">Plan Validity:</span>
            <span className="value">
              {userPlanByUserId?.planValidity || "--"}
            </span>
          </div>
          <div className="detail-row">
            <span className="label">Days Left:</span>
            <span className="value">
              {userPlanByUserId?.daysLeft || "--"}
            </span>
          </div>
          <div className="detail-row">
            <span className="label">Start:</span>
            <span className="value">
              {userPlanByUserId?.subscribeDateStart || "--"}
            </span>
          </div>
          <div className="detail-row">
            <span className="label">End:</span>
            <span className="value">
              {userPlanByUserId?.subscribeDateEnd || "--"}
            </span>
          </div>
        </section>

        <section className="card">
          <h2>Performance</h2>
          <div className="detail-row">
            <span className="label">Total Trades:</span>
            <span className="value">248</span>
          </div>
          <div className="detail-row">
            <span className="label">Win Rate:</span>
            <span className="value">78%</span>
          </div>
          <div className="detail-row">
            <span className="label">Profit:</span>
            <span className="value">₹1,24,500</span>
          </div>
        </section>
      </div>

      {/* ✅ Toast container for notifications */}
      <ToastContainer position="top-center" autoClose={3000} hideProgressBar={false} />
    </div>
  );
};

export default Profile;
